'use strict'

module.exports = bail

function bail(err) {
  if (err) {
    throw err
  }
}



//////////////////
// WEBPACK FOOTER
// ./~/bail/index.js
// module id = 213
// module chunks = 168707334958949